import { toast } from 'react-toastify';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  GET_ROLESANDPERMISSIONS,
  GET_SUPPLIERROLE,
} from 'resources/actionTypes';
import {
  getRolesAndPermissionsService,
  getSupplierRolesApi,
} from 'services/RolesAndPermissionsService';

function* getRolesAndPermissions(action) {
  const payload = action.payload || '';
  const rolesAndPermissions = yield call(getRolesAndPermissionsService);

  const roles = rolesAndPermissions?.data?.map(
    (arrayValue) => arrayValue?.moduleKey
  );

  if (rolesAndPermissions.success) {
    if (payload) {
      const subRoles = rolesAndPermissions?.data?.map((parentModule) =>
        parentModule?.subModule?.map((arrayValue) => arrayValue?.moduleKey)
      );

      const dmmyArray = [...roles, ...subRoles.flat(), 'settings', 'logout'];
      localStorage?.setItem('rolesPermissions', JSON.stringify(dmmyArray));

      window.location.replace(`/${dmmyArray[0]}`);
    }

    yield put({
      type: GET_ROLESANDPERMISSIONS.GET_ROLESANDPERMISSIONS_SUCCESS,
      rolesAndPermissions: rolesAndPermissions?.data,
    });
  } else {
    yield put({
      type: GET_ROLESANDPERMISSIONS.GET_ROLESANDPERMISSIONS_FAILED,
      message: rolesAndPermissions.message,
    });
    toast.error(
      rolesAndPermissions?.message || 'Fetching roles and permissions failed'
    );
  }
}

export function* getRolesAndPermissionsWatcher() {
  yield takeEvery(
    GET_ROLESANDPERMISSIONS.GET_ROLESANDPERMISSIONS_REQUESTED,
    getRolesAndPermissions
  );
}

function* getSupplierRoles(action) {
  const payload = action.payload || {};
  const supplierRoles = yield call(getSupplierRolesApi, payload);

  if (supplierRoles.success) {
    yield put({
      type: GET_SUPPLIERROLE.GET_SUPPLIERROLE_SUCCESS,
      supplierRoles: supplierRoles?.data,
    });
  } else {
    yield put({
      type: GET_SUPPLIERROLE.GET_SUPPLIERROLE_FAILED,
      message: supplierRoles.message,
    });
    toast.error(supplierRoles?.message || 'Fetching roles failed');
  }
}

export function* getSupplierRoleWatcher() {
  yield takeEvery(
    GET_SUPPLIERROLE.GET_SUPPLIERROLE_REQUESTED,
    getSupplierRoles
  );
}
